import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

export default function About() {
  return (
    <div>
      <Header />
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '2rem',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h1 style={{
          textAlign: 'center',
          color: '#333',
          marginBottom: '3rem',
          fontSize: '2.5rem',
          fontWeight: 'bold'
        }}>
          About Honor Society Tutors
        </h1>

        {/* Goals Section */}
        <section style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            color: '#04d664',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            borderBottom: '2px solid #04d664',
            paddingBottom: '0.5rem'
          }}>
            Mission
          </h2>
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            Built by high school students, our platform's mission is to foster a more collaborative learning environment within local school communities. The program now serves eleven schools across Manhattan Beach and Lawndale. We connect students from Mira Costa High School, Manhattan Beach Middle School, and Manhattan Beach elementary schools with Honor Society tutors at Mira Costa who are passionate about giving back. We recently expanded to Lawndale, where Lawndale High School tutors now support <Link to="/directory/ja" style={{color: '#04d664', textDecoration: 'underline'}}>Jane Addams Middle School students</Link> and Leuzinger High School tutors support <Link to="/directory/wr" style={{color: '#04d664', textDecoration: 'underline'}}>Will Rogers Middle School students</Link>, further strengthening cross-campus academic collaboration.
          </p>
        </section>

        {/* Schools Section */}
        <section style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            color: '#04d664',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            borderBottom: '2px solid #04d664',
            paddingBottom: '0.5rem'
          }}>
            Schools
          </h2>
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            Want HonorSocietyTutors at your school? We team up with your high school's Honor Society to match their members with students looking for tutors. We'll provide the platform free of charge to your school. Contact us to get started.
          </p>
        </section>

        {/* Motivation Section */}
        <section style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            color: '#04d664',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            borderBottom: '2px solid #04d664',
            paddingBottom: '0.5rem'
          }}>
            Motivation
          </h2>
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            During the pandemic I began to feel overwhelmed by my schoolwork. My parents eventually found a tutor who helped me get back on track. I realized that the best tutors are often students who are familiar with the same classes and even the same teachers I have. That's where I believe peer tutoring makes the biggest difference - these tutors have succeeded in the very same classes before.
	</p>
	<p style={{
  	  color: '#666',
  	  fontSize: '1.1rem',
  	  lineHeight: '1.8'
	}}>          
	 This past summer, I learned to code and built this website to help students connect with Peer Tutors. I strongly believe in the value of peer tutoring for both the student and the tutor, not only for improving academic performance but also for fostering mentorship between upperclassmen and younger students. Studies have shown that peer tutoring can significantly enhance academic achievement and confidence for both participants. <a
   	  href="https://www.ejmste.com/download/peer-tutoring-and-academic-achievement-in-mathematics-a-meta-analysis-5265.pdf"
    	  target="_blank"
    	  rel="noopener noreferrer"
    	  style={{
      	    color: '#666',
      	    textDecoration: 'none',
      	    fontWeight: 'bold'
    	  }}
  	>
	 (Academic Benefits of Peer Tutoring, 2018)
	</a>
	</p>
	<p style={{
  	 color: '#666',
  	 fontSize: '1.1rem',
  	 marginTop: '1rem'
	}}>
  	- Riya Dhillon
	</p>
        </section>

        {/* Contact Section */}
        <section style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            color: '#04d664',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            borderBottom: '2px solid #04d664',
            paddingBottom: '0.5rem'
          }}>
            Contact
          </h2>
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            <a 
              href="mailto:HonorSocietyScholars@gmail.com"
              style={{
                color: '#04d664',
                textDecoration: 'none',
                fontWeight: 'bold',
                transition: 'color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.color = '#029c47'}
              onMouseLeave={(e) => e.target.style.color = '#04d664'}
            >
              HonorSocietyScholars@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
